/* eslint-disable no-underscore-dangle */
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { MMTradesEndpointEnum } from "../../../enums/endpoints";
import { MMTRADES_API_URL } from "../../../utils/env";
import { IFormattedMMTrade, MMTradeExchange } from "./useMMTrades";

interface IMMTradesResponse {
  message: string;
  success: boolean;
  data: any[];
}

export const useMMTradesAllAssets = (
  start_time: string,
  end_time?: string,
  exchange?: MMTradeExchange,
  showAllTrades?: boolean
) => {
  const { tokenId } = useContext(AuthContext);
  const [data, setData] = useState<IFormattedMMTrade[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setData(undefined);
    setIsLoading(true);

    const fetchTrades = async () => {
      const params: { [key: string]: any } = {
        start_time: String(start_time), // Ensure it's a string
      };
      if (end_time) {
        params.end_time = String(end_time); // Ensure it's a string
      }
      if (exchange) params.exchange = exchange;
      if (showAllTrades) params.all_trades = true;

      try {
        const response = await axios.get<IMMTradesResponse>(
          MMTRADES_API_URL(MMTradesEndpointEnum.MM_TRADES),
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${tokenId}`,
              "Access-Control-Allow-Origin": "*",
            },
            params,
          }
        );

        const positions = response.data.data;
        // eslint-disable-next-line no-console
        console.log("useMMTradesAllAssets - Raw API data length:", positions.length);
        // eslint-disable-next-line no-console
        console.log("useMMTradesAllAssets - API params sent:", params);
        const formattedRows = positions.map((item: any) => ({
          date_time: item._DateTime ?? "",
          exchange: item.Exchange,
          instrument_name: item.InstrumentName,
          side: item.Side,
          price: item.Price,
          amount: item.Amount,
          is_taker: item.IsTaker,
          trade_id: item.TradeId,
          order_id: item.OrderId,
          fees: item.Fees,
          // timestamp for mm_trade_history is in milliseconds
          timestamp: item._Timestamp,
        }));
        // eslint-disable-next-line no-console
        console.log("useMMTradesAllAssets - Formatted rows length:", formattedRows.length);
        setData(formattedRows);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (tokenId) {
      fetchTrades();
    }
  }, [tokenId, start_time, end_time, exchange, showAllTrades]);

  return { data, isLoading };
};
